import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthSetup, RequireAuth } from "./auth/auth";
import { BookingsPage } from "./dashboard/BookingsPage";
import { DashboardLayout } from "./dashboard/DashboardLayout";
import { EmbedPage } from "./dashboard/EmbedPage";
import { LinksPage } from "./dashboard/LinksPage";
import { TenantsPage } from "./dashboard/TenantsPage";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { DemoPage } from "./pages/DemoPage";
import { LandingPage } from "./pages/LandingPage";
import { LinkDemoPage } from "./pages/LinkDemoPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import {
  AcmeAlertsPage,
  AcmeDashboardPage,
  AcmeFunnelsPage,
  AcmeIntegrationsPage,
  AcmeLayout,
  AcmeReportsPage,
} from "./tour/acme/AcmeApp";
import { TourDashboard, TourRoot } from "./tour/TourPages";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/l/:token" element={<LinkDemoPage />} />
        {/* Auth only mounts on the routes that need it, so public pages never load OIDC state. */}
        <Route
          path="/auth/callback"
          element={
            <AuthSetup>
              <AuthCallbackPage />
            </AuthSetup>
          }
        />
        <Route
          path="/app"
          element={
            <AuthSetup>
              <RequireAuth>
                <DashboardLayout />
              </RequireAuth>
            </AuthSetup>
          }
        >
          <Route index element={<Navigate to="links" replace />} />
          <Route path="links" element={<LinksPage />} />
          <Route path="embed" element={<EmbedPage />} />
          <Route path="bookings" element={<BookingsPage />} />
          <Route path="workspaces" element={<TenantsPage />} />
        </Route>
        {/* Screen-shared into demo calls by the guide; sample data only, no sign-in. */}
        <Route path="/tour" element={<TourRoot />}>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<LandingPage />} />
          <Route path="app" element={<TourDashboard />}>
            <Route index element={<Navigate to="links" replace />} />
            <Route path="links" element={<LinksPage />} />
            <Route path="embed" element={<EmbedPage />} />
            <Route path="bookings" element={<BookingsPage />} />
          </Route>
          {/* Acme Analytics, a fictional TryLook customer whose guide demos its own sample product. */}
          <Route path="acme" element={<AcmeLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AcmeDashboardPage />} />
            <Route path="funnels" element={<AcmeFunnelsPage />} />
            <Route path="alerts" element={<AcmeAlertsPage />} />
            <Route path="reports" element={<AcmeReportsPage />} />
            <Route path="integrations" element={<AcmeIntegrationsPage />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
